import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../styles/Balance.css";
import refreshIcon from "../assets/refresh.png";
import RedisInfo from "../services/RedisInfo";
// Rate limiting removed as per requirement

// CRITICAL FIX: Add fallback for API URL if not set during build
const apiUrl = process.env.REACT_APP_API_URL || window.location.origin;

const Balance = () => {
  const { t } = useTranslation();
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);

  const getBalanceClass = () => {
    if (balance < 10000) {
      return "balance-amount low-balance";
    }
    if (balance >= 10000 && balance <= 15000) {
      return "balance-amount medium-balance";
    }
    return "balance-amount";
  };

  const getBalanceStatusMessage = () => {
    if (balance < 10000) {
      return {
        text: "Digital services cannot be started, please top-up amount (min balance needed : Rs 10,000+)",
        className: "balance-status-message status-error",
      };
    }
    if (balance >= 10000 && balance <= 15000) {
      return {
        text: "Low Balance for Digital services",
        className: "balance-status-message status-warning",
      };
    }
    return {
      text: "Sufficient Balance for Digital services",
      className: "balance-status-message status-success",
    };
  };

  useEffect(() => {
    fetchBalance();
  }, []);

  const fetchBalance = async () => {
  setLoading(true);
  try {
    // Rate limiting removed as per requirement - API calls are now unlimited
    
    // 1️⃣ Get fresh data from Redis
    const redisData = await RedisInfo.redisDetails();
    console.log("Redis Data:", redisData);
  
    // 2️⃣ Get values from Redis with localStorage fallback
    const forCode = "00";
    const outletCode = "00";
    // CRITICAL FIX: Read dealer code from sessionStorage with localStorage fallback (for backward compatibility)
    const dealerCode = redisData.MultiServiceDealerCode || 
      sessionStorage.getItem("multiServiceDealerCode") || 
      localStorage.getItem("multiServiceDealerCode");
    

    console.log("FundCheck Request Params:", { forCode, outletCode, dealerCode });

    // 3️⃣ Call your FundCheck API using Redis values
    const response = await fetch(`${apiUrl}/api/v1/FundCheck`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        CustCategory: "MASS",
        DealerCode: "MASS" + dealerCode,  // from Redis with fallback
        ForCode: forCode,                  // from Redis with fallback
        OutletCode: outletCode,            // from Redis with fallback
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      let errorData;
      try {
        errorData = JSON.parse(errorText);
      } catch (e) {
        errorData = { ErrorMsg: errorText };
      }

      // Rate limiting removed - no need to handle 429 errors

      throw new Error(`Network response was not ok: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log("API Response:", data);

    // CRITICAL FIX: Check for backend errors even when HTTP status is 200 OK
    // Backend returns 200 OK with ErrorCode: -1 for errors (like DNS resolution errors)
    if (data.ErrorCode === -1 || data.Status === "Error") {
      console.error("❌ Backend returned error:", data.ErrorMsg);
      // Log DNS errors specifically for debugging
      if (data.ErrorMsg && data.ErrorMsg.includes("DNS Resolution Error")) {
        console.error("⚠️ DNS Resolution Error - SAP API hostname cannot be resolved from production server");
        console.error("   This indicates a backend configuration issue, not a frontend issue");
        console.error("   Check application-prod.properties: sap.fundcheck.api.url");
      }
      // Don't show balance, but don't throw error either (fail gracefully)
      setBalance(0);
      setLoading(false);
      return;
    }

    // Rate limiting removed - no need to record API calls

    if (data.Data && data.Data.length > 0) {
      setBalance(data.Data[0].AMOUNT || 0);
    } else {
      setBalance(0);
    }
  } catch (error) {
    console.error("Error fetching balance:", error);
    // Check if it's a network error (CORS, DNS, etc.)
    if (error.message && (error.message.includes("Failed to fetch") || error.message.includes("NetworkError"))) {
      console.error("⚠️ Network error - Check if API URL is correct:", apiUrl);
      console.error("   Current API URL:", apiUrl || "NOT SET (using default)");
    }
    setBalance(0);
  }
  setLoading(false);
};

  const balanceStatus = getBalanceStatusMessage();

  return (
    <div className="balance-container shadow-sm p-8 rounded">
      <div className="balance-text">
        <span>{t("available_balance")}</span>
      </div>
      <div className="balance-amount-container">
        <span className={getBalanceClass()}>
          ₹ {balance.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
        </span>
        <button
          className={`refresh-button ${loading ? "refreshing" : ""}`}
          onClick={fetchBalance}
          disabled={loading}
        >
          <img src={refreshIcon} alt="Refresh" className="refresh-icon" />
        </button>
      </div>
      <p className={balanceStatus.className}>{balanceStatus.text}</p>
    </div>
  );
};

export default Balance;


